module.exports = __webpack_public_path__ + "img/Entia-Carreteras-y-edificaciones-6.cf5e1f23.webp";